import axios from 'axios'
import {waitForGet} from "../utils/api";

export const PAGEVIEWS_AGGREGATION_MINUTES_5 = "minutes_5"
export const PAGEVIEWS_AGGREGATION_HOUR = "hour"
export const PAGEVIEWS_AGGREGATION_DAY = "day"
export const PAGEVIEWS_AGGREGATION_MONTH = "month"

/**
 * Query contents with oql
 * @param {object} oql
 */
export const queryOql = (oql) => {
	return new Promise(async (resolve)=>{
		waitForGet(WP_OctaviusRocks_Admin.api,(get)=>{
			resolve(get.query(oql));
		})
	});
};

export const queryTopPageviews = (num, from, to)=>{
	const topContentIdsOql = {
		fields:[
			{
				field: "hits",
				operations: ["sum"],
				as: "hits"
			},
			"content_id",
			"content_type",
		],
		conditions:{
			entries:[...conditions],
			relation: "AND"
		},
		order_by:[ {field:"hits", direction: "DESC"}],
		group_by: [ "content_id"],
		limit: 10,
		page: 1,
	}
}

/**
 * in memory cache of fetched contents
 * SO NEVER CALL TO OFTEN
 */
const CACHED_CONTENTS = {};

/**
 * get post objects
 * @param contentIds
 * @return {Promise}
 */
export const getContents = (contentIds) => {
	return new Promise(resolve => {
		const cachedKeys = Object.keys(CACHED_CONTENTS);
		const missingContentIds = contentIds.filter( id => !cachedKeys.includes(id));
		if(missingContentIds.length > 0){
			fetchContents(missingContentIds).then(()=>{
				resolve(contentIds.map(id => CACHED_CONTENTS[id]));
			});
		} else {
			resolve(contentIds.map(id => CACHED_CONTENTS[id]));
		}
	});
};

/**
 * fetch contents from wordpress ajax endpoint
 * @param ids
 * @return {Promise<boolean>}
 */
const fetchContents = (ids) => postRequest(
		'oc_get_contents',
		{content_ids: ids}
	)
	.then(list => {
		const isSuccess = (typeof list === typeof []);
		if(isSuccess){
			for (let item of list){
				CACHED_CONTENTS[item.ID] = item;
			}
		}
		return isSuccess;
	});

/**
 * ajax request function
 * @param {string} action
 * @param {object} params
 */
const postRequest = (action, params = {}) => axios({
		method: 'post',
		url: ajaxurl+"?action="+action,
		responseType: "json",
		headers: {
			"Content-Type": "application/json",
		},
		data: params
	})
	.then(response => response.data)